import { ActionType_Interflow, ActionType_Order } from './types.js';
import { defaultUIAccessLevels, generateKeyNamesByAccessLevel } from '@nu-art/permissions-shared';
// Permission declaration
export const DomainNamespace_Actions = 'Action';
export const DomainNamespace_OrderEditor = 'Order Editor';
export const PermissionKey_ActionView = 'permission-key--action-view';
export const PermissionKey_ActionEdit = 'permission-key--action-edit';
export const ActionsCollectionPermissionKeys = {
    view: PermissionKey_ActionView,
    edit: PermissionKey_ActionEdit
};
export const OrderEditorPermissionKeys = generateKeyNamesByAccessLevel(DomainNamespace_OrderEditor, defaultUIAccessLevels);
export const actionTypes = [ActionType_Order, ActionType_Interflow];
export const actionSubTypeLabelMap = {
    'activate-protocol': 'Activate Protocol',
    admit: 'Admit',
    'consider-protocol': 'Consider Protocol',
    consult: 'Consult',
    discharge: 'Discharge',
    'h&p': 'H&P',
    poc: 'Nurse',
    restart: 'Restart',
    test: 'Test',
    treatment: 'Treatment',
};
export const OrderStatus_PendingSignature = 'pending-signature';
export const OrderStatus_Pending = 'pending';
export const OrderStatus_Collected = 'collected';
export const OrderStatus_InProcess = 'in-process';
export const OrderStatus_ProviderInputNeeded = 'provider-input-needed';
export const OrderStatus_Resulted = 'resulted';
export const OrderStatus_Seen = 'seen';
export const OrderStatus_Deleted = 'deleted';
export const OrderStatus_Revoked = 'revoked';
export const OrderStatuses = [
    OrderStatus_PendingSignature,
    OrderStatus_Pending,
    OrderStatus_Collected,
    OrderStatus_InProcess,
    OrderStatus_ProviderInputNeeded,
    OrderStatus_Resulted,
    OrderStatus_Seen,
    OrderStatus_Deleted,
    OrderStatus_Revoked,
];
export const OrderLabel_PendingSignature = 'Pending Signature';
export const OrderLabel_Pending = 'Pending';
export const OrderLabel__Collected = 'Collected';
export const OrderLabel_InProcess = 'In Process';
export const OrderLabel_ProviderInputNeeded = 'Provider Input Needed';
export const OrderLabel_Resulted = 'Resulted';
export const OrderLabel_Canceled = 'Canceled';
export const OrderLabels = [
    OrderLabel_PendingSignature,
    OrderLabel_Pending,
    OrderLabel__Collected,
    OrderLabel_InProcess,
    OrderLabel_ProviderInputNeeded,
    OrderLabel_Resulted,
    OrderLabel_Canceled
];
export const OrderLifecycle_PendingSignature = {
    status: OrderStatus_PendingSignature,
    label: OrderLabel_PendingSignature
};
export const OrderLifecycle_Pending = { status: OrderStatus_Pending, label: OrderLabel_Pending };
export const OrderLifecycle_Collected = { status: OrderStatus_Collected, label: OrderLabel__Collected };
export const OrderLifecycle_InProcess = { status: OrderStatus_InProcess, label: OrderLabel_InProcess };
export const OrderLifecycle_ProviderInputNeeded = {
    status: OrderStatus_ProviderInputNeeded,
    label: OrderLabel_ProviderInputNeeded
};
export const OrderLifecycle_Resulted = { status: OrderStatus_Resulted, label: OrderLabel_Resulted };
export const OrderLifecycle_Seen = { status: OrderStatus_Seen, label: OrderLabel_Resulted };
export const OrderLifecycle_Deleted = { status: OrderStatus_Deleted, label: OrderLabel_Canceled };
export const OrderLifecycle_Revoked = { status: OrderStatus_Revoked, label: OrderLabel_Canceled };
export const OrderLifecycleStates = {
    statuses: [
        OrderLifecycle_PendingSignature,
        OrderLifecycle_Pending, // status, label
        OrderLifecycle_Collected,
        OrderLifecycle_InProcess,
        OrderLifecycle_ProviderInputNeeded,
        OrderLifecycle_Resulted,
        OrderLifecycle_Seen,
        OrderLifecycle_Deleted,
        OrderLifecycle_Revoked,
    ],
    indexOf: (status, limitedList) => (limitedList ?? OrderLifecycleStates.statuses).findIndex(orderLifecycle => orderLifecycle.status === status)
};
export const OrderResolutionType_Manual = 'manual';
export const OrderResolutionType_Automatic = 'automatic';
export const OrderResolutionType_Parallel = 'parallel';
export const resolutionTypes = [OrderResolutionType_Manual, OrderResolutionType_Automatic, OrderResolutionType_Parallel];
export const OrderType_Labs = 'labs';
export const OrderType_Imaging = 'imaging';
export const OrderType_EKG = 'ekg';
export const OrderType_EDConsult = 'ed-consult';
export const OrderType_ProviderInputNeeded = 'provider-input-needed';
export const orderTypes = [OrderType_Labs, OrderType_Imaging, OrderType_EKG, OrderType_EDConsult, OrderType_ProviderInputNeeded];
export const OrderTypeMap = {
    [OrderType_Labs]: [
        OrderLifecycle_PendingSignature,
        OrderLifecycle_Pending,
        OrderLifecycle_Collected,
        OrderLifecycle_InProcess,
        OrderLifecycle_Resulted,
        OrderLifecycle_Seen
    ],
    [OrderType_Imaging]: [
        OrderLifecycle_PendingSignature,
        OrderLifecycle_Pending,
        OrderLifecycle_InProcess,
        OrderLifecycle_Resulted,
        OrderLifecycle_Seen,
    ],
    [OrderType_EKG]: [
        OrderLifecycle_PendingSignature,
        OrderLifecycle_Pending,
        OrderLifecycle_InProcess,
        OrderLifecycle_ProviderInputNeeded,
        OrderLifecycle_Seen,
    ],
    [OrderType_EDConsult]: [
        OrderLifecycle_Pending,
        OrderLifecycle_ProviderInputNeeded,
        OrderLifecycle_Seen,
    ],
    [OrderType_ProviderInputNeeded]: [
        OrderLifecycle_ProviderInputNeeded,
        OrderLifecycle_Seen,
    ],
};
export const cleanAction = Object.freeze({
    name: 'New Action',
    type: ActionType_Order,
    subType: 'test',
    variableIds: [],
    resolution: OrderResolutionType_Manual,
    tagGroups: [],
    isOrderSet: false,
});
//# sourceMappingURL=consts.js.map